const REPORT_FIELDS = {
  summary: [
    ['Description', 'DESCRIPTION'],
    ['Shape and Cutting Style', 'SHAPE AND CUT'],
  ],
  grading: [
    ['Measurements', 'Measurements'],
    ['Carat Weight', 'CARAT WEIGHT'],
    ['Color Grade', 'COLOR GRADE'],
    ['Clarity Grade', 'CLARITY GRADE'],
  ],
  additional: [
    ['Polish', 'POLISH'],
    ['Symmetry', 'SYMMETRY'],
    ['Fluorescence', 'FLUORESCENCE'],
    ['Comments', 'COMMENTS'],
  ],
};

function escapeHtml(value) {
  if (value === undefined || value === null) return '';
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function buildRows(fieldList, reportData) {
  return fieldList
    .map(
      ([label, key]) => `
        <tr>
          <td>${label}</td>
          <td class="text-right bold-text">${escapeHtml(reportData[key])}</td>
        </tr>`
    )
    .join('');
}

function buildReportHTML(reportData) {
  return `
    <div class="report report-left">
      <div class="overlay"></div>
      <h2 class="title-left">Report</h2>
      <h5>Issue Date / <span class="bold-text">${escapeHtml(reportData['REPORT DATE'])}</span></h5>
      <h3 class="table-title">Report Summary</h3>
      <table class="report-table">${buildRows(REPORT_FIELDS.summary, reportData)}</table>
      <h3 class="table-title">Grading Results</h3>
      <table class="report-table">${buildRows(REPORT_FIELDS.grading, reportData)}</table>
      <h3 class="table-title">Additional Grading Information</h3>
      <table class="report-table">${buildRows(REPORT_FIELDS.additional, reportData)}</table>
    </div>
    <div class="report report-right padtop">
      <h2 class="title-right">Proportions</h2>
      <div class="diamond_proportion_image">
        <img src="https://cdn.shopify.com/s/files/1/1359/2701/files/Group_1538235907.png?v=1728297172" />
        <span class="diamond-top-first-text">${escapeHtml(reportData['Girdle Thickness'])}</span>
        <span class="diamond-top-second-text">${escapeHtml(reportData['Table Size'])}</span>
        <span class="diamond-bottom-text">${escapeHtml(reportData['Culet'])}</span>
        <span class="diamond-left-text">${escapeHtml(reportData['Total Depth'])}</span>
      </div>
      <h4 class="title-right-md">Grading Scale</h4>
      <h4 class="title-right-md">Color</h4>
      <ul class="tablelist">
        <li><div class="font-bold">D - F</div><div>Colorless</div></li>
        <li><div class="font-bold">G - J</div><div>Near Colorless</div></li>
        <li><div class="font-bold">K - M</div><div>Slightly Tinted</div></li>
        <li><div class="font-bold">N - P</div><div>Very Light Color</div></li>
        <li><div class="font-bold">S - Z</div><div>Light Color</div></li>
        <li><div class="font-bold">FANCY</div><div></div></li>
      </ul>
      <h4 class="title-right-md">Clarity</h4>
      <ul class="tablelist">
        <li><div class="font-bold">IF</div><div>Internally Flawless</div></li>
        <li><div class="font-bold">VVS 1-2</div><div>Very Very Slightly Included</div></li>
        <li><div class="font-bold">VS 1-2</div><div>Very Slightly Included</div></li>
        <li><div class="font-bold">SI 1-2</div><div>Slightly Included</div></li>
        <li><div class="font-bold">I 1-3</div><div>Included</div></li>
      </ul>
    </div>`;
}

async function grabIGICertData() {
  // Cache the elements we touch more than once.
  const $mainSection = $('.igi-certificate-main-section');
  const $certDetails = $('.igi-cert-details');
  const $noDataFound = $('.no-data-found');

  function showEmptyState() {
    $mainSection.addClass('is-hide');
    $noDataFound.removeClass('is-hide');
    $certDetails.removeClass('is-hide');
    hideLoader();
  }

  showLoader();

  let reportNumber;
  try {
    reportNumber = atob(new URLSearchParams(window.location.search).get('rtn'));
  } catch (err) {
    console.error('Invalid or missing rtn param:', err);
    showEmptyState();
    return;
  }

  try {
    const response = await fetch(`${portalApiUrl}/get-igi-cert-data/${reportNumber}`);
    if (!response.ok) throw new Error(`Request failed with status ${response.status}`);

    const result = await response.json();
    const reportData = result?.data?.[0];
    const isValidReport = reportData && !reportData.Value;

    if (isValidReport) {
      $mainSection.append(buildReportHTML(reportData));
      $certDetails.removeClass('is-hide');
      hideLoader();
    } else {
      showEmptyState();
    }
  } catch (error) {
    console.error('Failed to load IGI certificate data:', error);
    showEmptyState();
  }
}

function manageSummaryContent() {
  $('#diamondCreationBtn').removeClass('tabs-card-btn-active');
  $('#summaryBtn').addClass('tabs-card-btn-active');
  $('.diamond-creation-details').addClass('is-hide');
  $('.igi-certificate-main-section').removeClass('is-hide');
}

function manageDiamondContent() {
  $('#diamondCreationBtn').addClass('tabs-card-btn-active');
  $('#summaryBtn').removeClass('tabs-card-btn-active');
  $('.diamond-creation-details').removeClass('is-hide');
  $('.igi-certificate-main-section').addClass('is-hide');
}

grabIGICertData();